/**
 * Weeks read from the backend during this page load.
 *
 * `savedSnapshotByWeek` in the store cannot answer this: it is persisted and
 * never pruned, so it also names weeks last read days ago in another session.
 * That matters because a week PUT is a whole-week REPLACE, writing one this
 * client has not read is how another device's edits get overwritten.
 *
 * Module scope rather than store state on purpose. "This session" ends when the
 * page unloads, which is exactly the lifetime of a module, and putting it in
 * the store would persist it and make the distinction meaningless.
 */
const readThisSession = new Set<string>()

export const markWeekReadThisSession = (weekStart: string): void => {
  readThisSession.add(weekStart)
}

export const weeksReadThisSession = (): string[] => [...readThisSession]

/**
 * Whether this week has already been shown once in this session.
 *
 * Used to tell a first load apart from a re-fetch of a week the user is already
 * looking at — the roster is in the store either way, so only the first one has
 * nothing to render but a placeholder.
 */
export const wasWeekReadThisSession = (weekStart: string): boolean =>
  readThisSession.has(weekStart)

/** Only for tests and for a restaurant switch, which invalidates the lot. */
export const forgetWeeksReadThisSession = (): void => {
  readThisSession.clear()
}
